import { Suspense, lazy } from 'react';

import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

const TerminalPage = Loader(lazy(() => import('src/content/pages/Terminal')));

const terminalRoutes = [
  {
    path: ':serverId',
    element: <TerminalPage />,
  }
];

export default terminalRoutes;
